module.exports = __webpack_public_path__ + "assets-cabinet/img/loading.03d17d74.svg";